import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Joyride from 'react-joyride';
import { stopJoyride } from '../../store/modules/options';

const mapActionCreators = {
  stopJoyride,
};

const mapStateToProps = state => ({
  runJoyride: state.options.runJoyride,
});

class JoyRideActivity extends React.Component {
  joyrideCallback = event => {
    if (event.action === 'close') {
      // this.props.stopJoyride();
    } else if (event.action === 'skip') {
      this.props.stopJoyride();
    }
  };

  render() {
    if (typeof this.props.runJoyride === 'undefined') {
      return null;
    }

    const joyrideSteps = [
      {
        title: 'Aktivitäten',
        text:
          'Hier finden Sie eine Übersicht über alle Aktivitäten in Ihrem Account. Auch die Ihrer KollegInnen.',
        selector: '.activity-index',
        position: 'top',
        type: 'hover',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
      {
        title: 'Alles eine Frage der Perspektive',
        text:
          'Sie können Aktivitäten auch in Kalenderform oder in detaillierter Fassung ausgeben',
        selector: '.activity-index .JoyrideActivitySearch',
        position: 'top',
        type: 'hover',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
      {
        title: 'Bis ins kleinste Detail',
        text:
          'An dieser Stelle können Sie sämtliche Aktivitäten nach einigen Kriterien filtern. Standardmäßig zeigen wir Ihnen alle Aktivitäten der letzten 6 Monate',
        selector: '.activity-index .JoyrideActivityFilter',
        position: 'top',
        type: 'hover',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
    ];

    return (
      <Joyride
        ref="joyride-activity"
        steps={joyrideSteps}
        run={this.props.runJoyride} // or some other boolean for when you want to start it
        // debug={__DEV__}
        showSkipButton
        showStepsProgress
        type="continuous"
        callback={this.joyrideCallback}
        locale={{
          back: 'Zurück',
          close: 'Schließen',
          last: 'Schließen',
          next: 'Weiter',
          skip: 'Tutorial beenden',
        }}
      />
    );
  }
}
JoyRideActivity.propTypes = {
  runJoyride: PropTypes.bool.isRequired,
  stopJoyride: PropTypes.func.isRequired,
};
JoyRideActivity.defaultProps = {
  runJoyride: false,
};
export default connect(mapStateToProps, mapActionCreators)(JoyRideActivity);



// WEBPACK FOOTER //
// ./src/components/JoyRideActivity/JoyRideActivity.js